export default __webpack_public_path__ + "static/media/accommodation1.95f86236.webp";